export * from "./case"
export * from "./currency"
export * from "./date"
export * from "./timeRequestStatuses"
export * from "./loadingText"
export * from "@components/Footer/components/AfterFooter/constants"
export * from "./roles"
export * from "./locales/ru"

export const HIDE_CARD_PAYMENT_MESSAGE = "Нет доступных скидок для записи на сессию"
